import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SessionUserViewModel, UserSessionState } from '../models/dssback/apiViewModels';
import { LoggerService } from './logger.service';
import { AppSettingsService } from './app-settings.service';

export const OI_URL = '/sotixsight/deviceAnalysis';
export const ACCOUNT_URL = '/sotixsight/account';
export const DID_URL = 'http://localhost:8026'; // Deprecated

@Injectable()
export class RestClientBaseService {
  _user: SessionUserViewModel;
  _state: UserSessionState;

  constructor(
    protected http: HttpClient,
    protected appSettingsService: AppSettingsService,
    protected logger: LoggerService
  ) {}

  get user(): SessionUserViewModel {
    return this._user;
  }

  logout(): void {
    try {
      sessionStorage.clear();
      const url = new URL(`${ACCOUNT_URL}/auth/logout`);
      url.hostname = window.location.hostname;
      window.location.href = url.toString();
    } catch (error) {
      this.logger.error('Error Occurred during logout. ' + error);
    }
  }

  getSessionState(): Observable<UserSessionState> {
    window['addTiming'] && window['addTiming']('RestClientBaseService:getSessionState');

    const accountServiceUrl = this.ensureTrailingSlash(this.appSettingsService.accountServiceUrl);

    if (!this._state?.user) {
      return this.http.get<UserSessionState>(`${accountServiceUrl}user/state`).pipe(
        map(state => {
          this._user = state.user;
          this._state = state;
          return this._state;
        })
      );
    }
    return of(this._state);
  }

  userHasTag(user: SessionUserViewModel, tag: string): boolean {
    return user.tags[tag] === true;
  }

  private ensureTrailingSlash(url: string): string {
    if (!url.endsWith('/')) {
      return url + '/';
    }
    return url;
  }
}
